// extracted by mini-css-extract-plugin
module.exports = {"sharedWithOtherCourses":"SharedWithOtherCourses_sharedWithOtherCourses___PE0j","otherCourseLink":"SharedWithOtherCourses_otherCourseLink__2GvxV"};